import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { LegacyComponent } from './legacy.component';
import { TextMaskModule } from 'angular2-text-mask';
import { DirectivesModule, ScTableModule, TitleModule, ButtonModule } from '@sc/portal.fe.lib.ui-core-components';
import { PipesModule } from '../../shared/pipes/pipes.module';
import { SharedComponentsModule } from '../shared/shared-components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@sc/pas-common';
import { IconModule } from '@sc/portal.fe.lib.ui-core-components';
import { BannerModule } from '@sc/portal.fe.lib.ui-core-components';

const components = [
    LegacyComponent
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedComponentsModule,
        PipesModule,
        CoreModule,
        DirectivesModule,
        TextMaskModule,
        ScTableModule,
        TitleModule,
        ButtonModule,
        BannerModule,
        IconModule
    ],
    declarations: components,
    exports: components,
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LegacyModule {
}
